import { useParams } from 'react-router-dom';
import {
  LabResultDetailsTable,
  LabResultInfo,
  LabResultProvider,
} from '../../components/lab-results/detail';

function LabResultsDetailPage() {
  const { id } = useParams();

  return (
    <div className="m-8">
      Lab Results Detail Page
      <LabResultProvider id={id}>
        <div className="mt-8 max-w-[40rem]">
          <LabResultInfo />
        </div>
        <div className="mt-8 w-full">
          <LabResultDetailsTable />
        </div>
      </LabResultProvider>
    </div>
  );
}

export default LabResultsDetailPage;
